'use strict';

function pdfPopover () {
  $('.pdf-popover').popover({
    trigger: 'focus',
    container: 'body',
    placement: 'bottom',
    html: true
  });
}

module.exports = pdfPopover;
